import { useLocation, useParams, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import { Stack, Button, Chip, Typography } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'
import BoardView from '@components/Board/BoardView'
import { userSend } from 'api/users';
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'
import { typography } from '@/theme'

export default function NoticeView() {
  const navigate = useNavigate();
  const location = useLocation();
  const lang = useLang()
  const { id } = useParams();
  const { isMobile } = useIsMobile();

  const searchYn      = location.state?.searchYn;
  const navParamData  = location.state?.navParamData; // 조회조건
  const searchData    = location.state?.rowData;      // 선택 정보(상세조회조건)

  // 데모 데이터
  const fetcher = useCallback(
    async () => {

      const params = {
        bbsId : searchData?.bbsId,
      }
    
      const res = await userSend('/alarm/getNoticeDetail', params);
      
      return {
        id : res.data?.bbsId,
        title: (
          <Stack direction="row" spacing={1} alignItems="center">
            {(res.data?.upendYn === 'Y' || res.data?.noticeYn === 'Y') && (
              <Chip
                label={res.data?.upendYn === 'Y' ? '전체' : res.data?.noticeYn === 'Y' ? '공지'  : '' }
                variant="outlined"
                color={res.data?.upendYn === 'Y' ? 'primary' : res.data?.noticeYn === 'Y' ? 'grey' : '' }
                size="small"
              />
            )}
            <Typography component="p" variant={isMobile ? 'subtitle2' : 'subtitle1'} fontWeight={700}>
              {res.data?.bbsTitle}
            </Typography>
          </Stack>
        ),
        author : res.data?.registNm,
        createdAt : res.data?.registDttm,
        views : res.data?.viewCnt,
        content : res.data?.bbsSubstatnce,
        attachments: res.data?.noticeAttachFileUrl && ([
          { name: res.data?.noticeAttachFileName, url: res.data?.noticeAttachFileUrl }
          // { name: '[이용안내] 방송대·전문대교협,가상실습 콘텐츠 공유로 교육 협력 새 장 연다.hwp', url: '/files/file.pdf' },
          // { name: '가상실험실습_안내문.pdf', url: '/files/file.pdf' },
        ]),
      }
  }, [id])

  return (
    <BoardView
      fetcher={fetcher}
      bottomToolbarRender={() => (
        <Stack direction="row" justifyContent="flex-end">
          <Button 
            variant="contained" 
            size="large"
            sx={{ width: isMobile ? '100%' : 'auto'}} 
            onClick={() => {
              navigate(buildLangHref('/alarm/notice', lang), { state: { searchYn : searchYn, navParamData : navParamData} });
            }}
          >
            목록
          </Button>
        </Stack>
      )}
    />
  )
}